export const LampIcon = (props) => (
  <svg
    style={props?.style}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.5001 10.9995H5.9706C5.8221 10.363 5.1521 9.8425 4.8771 9.4995C4.4062 8.91114 4.11108 8.20173 4.02573 7.45298C3.94039 6.70423 4.0683 5.9466 4.39473 5.26737C4.72116 4.58814 5.23282 4.01494 5.87078 3.61379C6.50874 3.21265 7.24704 2.99988 8.00064 3C8.75424 3.00012 9.49248 3.21312 10.1303 3.61447C10.7681 4.01582 11.2796 4.58919 11.6058 5.26853C11.932 5.94786 12.0597 6.70553 11.9741 7.45426C11.8885 8.20298 11.5932 8.9123 11.1221 9.5005C10.8471 9.843 10.1781 10.3635 10.0296 10.9995H8.5001V8.4995H7.5001V10.9995ZM10.0001 11.9995V12.4995C10.0001 12.7647 9.89474 13.0191 9.70721 13.2066C9.51967 13.3941 9.26532 13.4995 9.0001 13.4995H7.0001C6.73489 13.4995 6.48053 13.3941 6.293 13.2066C6.10546 13.0191 6.0001 12.7647 6.0001 12.4995V11.9995H10.0001Z'
      fill='#F59E0B'
    />
  </svg>
);
